<template>
	<div class="clearfix">
		<input
			:id="action + name + random"
			type="checkbox"
			class="check_input"
			:checked="switch_checked"
			@change="handleSelect"
			:disabled="switch_disabled"
		/>

		<label class="checkbox" :for="action + name + random"></label>
		<label
			class="check-label"
			:for="action + name + random"
			v-html="label"
		></label>
	</div>
</template>
<script>
export default {
	name: 'CheckBox',
	model: {
		prop: 'checked',
		event: 'change',
	},
	props: {
		checked: Boolean,
		label: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: '',
		},
		action: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			switch_checked: this.checked,
			switch_disabled: this.disabled,
			random: 0,
		};
	},
	methods: {
		handleSelect(event) {
			this.$emit('change', event.target.checked);
		},
		generateRandom() {
			this.random = Math.round(Math.random() * 100000);
		},
	},
	watch: {
		checked() {
			this.switch_checked = this.checked;
			this.$emit('change', this.switch_checked);
		},
		disabled() {
			this.switch_disabled = this.disabled;
		},
	},
	mounted() {
		this.generateRandom();
	},
};
</script>

<style lang="less"></style>
